import React, { useState, useContext } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { ManageContext } from "../Manage";
import { useIsMounted } from "services/customHooks/useIsMounted";
import { CompanyApi } from "services/apis/CompanyApi";
import { showInfoNotification } from "components/framework/notification/NotificationUtil";
import { handleError } from "services/util/ApiUtil";
import ConfirmationModal from "components/framework/modals/ConfirmationModal";

type Props = {
  id: string;
  name: string;
  closeModal: () => void;
};

export default function OrganizationDeleteModal(props: Props) {
  const intl = useIntl();
  const [showLoadingIndicator, setShowLoadingIndicator] = useState(false);
  const manageContext = useContext(ManageContext);
  const isMounted = useIsMounted();

  const handleDelete = () => {
    if (isMounted.current) {
      setShowLoadingIndicator(true);
    }

    CompanyApi.delete(props.id)
      .then(() => {
        showInfoNotification(intl.formatMessage({ id: "manage.organization.delete.deleteNotification" }));
        if (isMounted.current) {
          manageContext.organizationCallback();
          props.closeModal();
        }
      })
      .catch(error => handleError(error))
      .finally(() => {
        if (isMounted.current) {
          setShowLoadingIndicator(false);
        }
      });
  };

  return (
    <ConfirmationModal
      confirmCallback={handleDelete}
      closeModal={props.closeModal}
      title={intl.formatMessage({ id: "manage.organization.delete.deleteModalTitle" })}
      confirmButtonText={intl.formatMessage({ id: "manage.organization.delete.submitDelete" })}
      showLoadingIndicator={showLoadingIndicator}>
      <p>
        <FormattedMessage id="manage.organization.delete.deleteQuestion" values={{ organization: props.name }} />
      </p>
    </ConfirmationModal>
  );
}
